interface Props {
  size?: number;
  variant?: 'gold' | 'dark' | 'full';
  className?: string;
}

/** Bag Tag brand mark — header uses small icon; `full` uses lockup for hero watermarks. */
export function Crest({ size = 56, variant = 'gold', className = '' }: Props) {
  const src = variant === 'full' ? '/logo-full.png' : '/logo-header.png';
  return (
    <img
      src={src}
      alt="Bag Tag"
      width={size}
      height={size}
      decoding="async"
      className={`block object-contain ${className}`.trim()}
    />
  );
}
